import { AfterContentInit, Component, ContentChild, ElementRef, HostBinding, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AvatarBlockDescriptionDirective, AvatarBlockTitleDirective } from './avatar-block.directive';
import { MatChip } from '@angular/material/chips';
import { HostListenerService } from '../../../../services/host-listener.service';

export enum AvatarBlockTypes {
    INITIALS = 'initials',
    ICON = 'icon',
    SVG = 'svg',
    IMG = 'img',
}

@Component({
    selector: 'app-avatar-block',
    templateUrl: './avatar-block.component.html',
    styleUrls: ['./avatar-block.component.scss'],
    host: { class: 'avatar-block-container' },
})
export class AvatarBlockComponent implements OnChanges, OnInit, AfterContentInit
{
    @Input() iconImage: string;
    @Input() icon: string;
    @Input() iconOnly = false;
    @Input() svgIcon: string;
    @Input() initials: string;
    @Input() badge = 0;
    @Input() size: 'sm' | 'md' | 'lg' | 'xl';
    @Input() isLoadingInitialData = false;
    @Input() wrappedText = false;
    @Input() inVirtualScroll = false;

    @HostBinding('class.heading-block') headingClassValue = false;
    @HostBinding('class.wrapped-text') wrappedTextClassValue = false;

    @ContentChild(AvatarBlockTitleDirective) titleRef!: AvatarBlockTitleDirective;
    @ContentChild(AvatarBlockDescriptionDirective) descriptionRef!: AvatarBlockDescriptionDirective;
    @ContentChild(MatChip) chipRef!: MatChip;

    iconType: AvatarBlockTypes = AvatarBlockTypes.INITIALS;
    iconTypes = AvatarBlockTypes;
    classMapping: { [prop: string]: boolean; } = {};

    constructor(
            private _host: HostListenerService,
            private _elementRef: ElementRef
    ) {
    }

    @HostBinding('class.with-mat-chip') get withMatChipClass() {
        return this.chipRef && !this._host.smBreakpoint$.getValue();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes) {
            if (changes.hasOwnProperty('iconImage') && this.iconImage !== '') {
                this.iconType = AvatarBlockTypes.IMG;
            } else if (changes.hasOwnProperty('svgIcon') && this.svgIcon) {
                this.iconType = AvatarBlockTypes.SVG;
            } else if (changes.hasOwnProperty('icon') && this.icon) {
                this.iconType = AvatarBlockTypes.ICON;
            } else if (changes.hasOwnProperty('initials') && this.initials) {
                this.iconType = AvatarBlockTypes.INITIALS;
            }

            if (changes.hasOwnProperty('size')) {
                this.classMapping = {
                    sm: this.size === 'sm',
                    md: this.size === 'md',
                    lg: this.size === 'lg',
                    xl: this.size === 'xl'
                };
            }

            if (changes.hasOwnProperty('wrappedText')) {
                this.wrappedTextClassValue = this.wrappedText;
            }
        }
    }

    ngOnInit() {
        if (!this.size) {
            this.size = 'lg';
            this.classMapping = { 'lg': true };
        }
    }

    ngAfterContentInit() {
        if (this.titleRef) {
            this.headingClassValue = this.titleRef._el.nativeElement.nodeName === 'H2';
            this.titleRef._el.nativeElement.innerHtml = this.titleRef.title;
        }

        if (this.descriptionRef) {
            this.descriptionRef._el.nativeElement.innerHtml = this.descriptionRef.description;
        }
    }
}
